// right now only used by init-form.js
function getUrlParams(link) {
  var url = link;
    url = url.replace(/__EQUAL__/g, "=");
    url = url.replace(/%3D/g, "=");
    url = url.replace(/amp_r=/g, "");
    url = url.replace(/%20/g, " ");
    url = url.replace(/%2520/g, " ");
    url = url.replace(/%26/g, "&");
    url = url.replace(/%2F/g, "/");
    url = url.replace(/%3F/g, "?");

  var regex = /[?&]([^=#]+)=([^&#]*)/g;
  var AFSParam = {};
  var match;
  while (match = regex.exec(url)) {
    AFSParam[match[1]] = match[2];
  }
  return AFSParam;
}